class PdCoockie {
  lifetime = 365 * 24 * 60 * 60;

  constructor() {
    if (`; ${document.cookie};`.indexOf("; pdcookies=") !== -1) return;
    this.show();

    $('[data-cookie-warn-close]').click(() => {
      this.hide();
    })
  }

  show() {
    $("body").addClass("withCoockie")
    $('body').append(`
      <section class="cookieWarn" data-cookie-warn>
        <div class="cookieWarn__content">
          <p class="cookieWarn__text">
            Korzystanie z witryny oznacza zgodę na wykorzystanie plików cookie. Więcej informacji możesz znaleźć w
            <a class="cookieWarn__link" href="/polityka-prywatnosci" title="polityka prywatności">
              polityce prywatności.
            </a>
          </p>
          <button class="cookieWarn__close" data-cookie-warn-close>Akceptuję</button>
        </div>
      </section>
    `);
  }

  hide() {
    document.cookie = `pdcookies=1;max-age=${this.lifetime};path=/`
    $('body').removeClass('withCoockie');
    $('[data-cookie-warn]').hide();
  }
}

readyCallbacks.add(() => {
  new PdCoockie();
});